
export default {
  name: "Blockquote",
  props: {
    block: { type: Object, required: true },
  },
};
